import { useCallback } from 'react';
import { Phone } from '@mui/icons-material';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { InputAdornmentWrapper } from '@styles/InputStyles';
import { ITextInputProps, TextInput } from '../TextInput';
import { PhoneNumberMask } from './PhoneNumberMask';

export const PhoneInput = ({ isAbleToCall, ...props}: ITextInputProps) => {
  const onPhoneCall = useCallback(() => {
    if (isAbleToCall) {
      if ((props.value as string).length !== 10) {
        Notistack.generalError('Please insert correct contact number to call!');
      } else {
        window.open(`tel:+${props.value}`);
      }
    }
  }, [props.value, isAbleToCall]);

  return (
    <TextInput
      {...props}
      type="tel"
      InputProps={{
        inputComponent: PhoneNumberMask,
        endAdornment: (
          <InputAdornmentWrapper position="end" $isAbleToCall={isAbleToCall ?? false}>
            <Phone onClick={onPhoneCall} />
          </InputAdornmentWrapper>
        ),
      }}
    />
  );
};
